//@flow
import * as Immutable from 'immutable';

import { EmailAddress } from 'common/models/flow/EmailAddress';
import type { EmailAddressModelType } from 'common/models/flow/EmailAddress';

import DataUtils from 'common/utils/DataUtils';
import StringUtils from 'common/utils/StringUtils';
import { validatable, validate } from 'common/utils/ValidationUtil';

import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['settings'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalEmailAddress extends EmailAddress {
    static fromJS(json: EmailAddressModelType): InternalEmailAddress {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @validate
    setEmailAddress(emailAddress: string): this {
        return super.setEmailAddress(emailAddress);
    }

    validateEmailAddress() {
        if (
            !DataUtils.isEmpty(this.emailAddress) &&
            !StringUtils.isEmail(this.emailAddress)
        ) {
            return nsTranslate('errorMessage.invalidEmailFormat');
        }
    }
}

export { InternalEmailAddress as EmailAddress };
